module.exports = __webpack_public_path__ + "static/media/netlify.f993bf1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/netlify.png
// module id = 154
// module chunks = 0